import { useState, useEffect } from 'react';
import { getAdminRole, type AdminRole } from '@/lib/admin/roles';

export function useAdminRole(): { role: AdminRole | null; loading: boolean } {
  const [role, setRole] = useState<AdminRole | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getAdminRole()
      .then((r) => { if (!cancelled) setRole(r); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { role, loading };
}
